"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.RuleMeasure = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var RuleMeasure = /*#__PURE__*/function () {
  function RuleMeasure(code) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var readonly = arguments.length > 2 ? arguments[2] : undefined;
    var vincolo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    (0, _classCallCheck2["default"])(this, RuleMeasure);
    this.cod = null;
    this.value = null;
    this.readonly = false;
    this.vincolo = null;
    this.cod = code;
    this.value = value ? value : 0;
    this.readonly = readonly;
    this.vincolo = vincolo;
  }
  (0, _createClass2["default"])(RuleMeasure, [{
    key: "setValue",
    value: function setValue(newVal) {
      if (isNaN(newVal)) newVal = 0;
      var correctValue = newVal;
      if (this.vincolo) {
        if (correctValue < this.vincolo.inidim - this.vincolo.min) {
          correctValue = this.vincolo.inidim - this.vincolo.min;
        }
        if (correctValue > this.vincolo.inidim + this.vincolo.max) {
          correctValue = this.vincolo.inidim + this.vincolo.max;
        }
      }
      this.value = correctValue;
    }
  }]);
  return RuleMeasure;
}();
exports.RuleMeasure = RuleMeasure;
//# sourceMappingURL=RuleMeasure.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/RuleMeasure.js
// module id = 478
// module chunks = 142